import React, { useCallback, useRef, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Button, Col, Row } from 'react-bootstrap';
import { FaExchangeAlt } from 'react-icons/fa';

import { useToast } from '../../../hooks/toast';

import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import Loading from '../../../components/Loading';
import { IAgendaSala } from '..';
import Input from '../../../components/Input';
import { gerarCodigoAlfanumerico } from '../../../utils/funcoes';
import Select from '../../../components/Select';

interface FormDados {
  tipoMidia: string;
  ConNome: string;
  NomeSala: string;
}
type ComponentProps = {
  tokenPainel: IAgendaSala;
};

export const caracterSplitMidiaPainel = ':#:';

const optionsTipoMidia = [
  { label: 'YouTube', value: 'youtube' },
  { label: 'Storage', value: 'storage' },
  { label: 'Imagem/PNG', value: 'imagem' },
];

const TokenPainel: React.FC<ComponentProps> = ({ tokenPainel }) => {
  const { addToast } = useToast();
  const formRefParcela = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const InitialData: FormDados = {
    tipoMidia: tokenPainel.ConNome.split(caracterSplitMidiaPainel)[0] || 'ND',
    ConNome: tokenPainel.ConNome.split(caracterSplitMidiaPainel)[1] || 'ND',
    NomeSala: tokenPainel.NomeSala,
  };

  const handleSubmit = useCallback(
    async (dados: FormDados) => {
      try {
        setLoading(true);

        const token = gerarCodigoAlfanumerico(5);
        formRefParcela.current?.setFieldValue('NomeSala', token);
        const dadosSala: IAgendaSala = {
          ConCodigo: tokenPainel.ConCodigo,
          ConNome: `${dados.tipoMidia}${caracterSplitMidiaPainel}${dados.ConNome}`,
          NomeSala: token,
        };
        await api.post(`/salas`, dadosSala);
      } catch (error: any) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro alterar Token',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, tokenPainel],
  );

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      <Form
        ref={formRefParcela}
        initialData={InitialData}
        onSubmit={handleSubmit}
      >
        <Row noGutters className="bg-light text-dark p-1">
          <Col md={2} className="px-1">
            <Select
              name="tipoMidia"
              label="Tipo Mídia"
              options={optionsTipoMidia}
            />
          </Col>
          <Col md={3} className="px-1">
            <Input
              name="ConNome"
              textUppercase={false}
              label="Código/Url"
              placeholder=""
            />
          </Col>
          <Col md={2} className="px-1">
            <Input name="NomeSala" label="Token" placeholder="Token" />
          </Col>

          <Col
            md={2}
            className="d-flex justify-content-between align-items-center px-1"
          >
            <Button
              data-id={tokenPainel.ConCodigo}
              type="submit"
              size="sm"
              style={{ padding: '1px 8px' }}
              className="bg-success"
            >
              <FaExchangeAlt size={14} />
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default TokenPainel;
